export default "/images/large-exit-icon.svg?0afb5830fe86e4a254d5a654f3296be9";